import React from 'react';
import { Head } from '@inertiajs/react';
import type { DevelopersPageProps } from '../types/developers';
import DocsNav from '../components/developers/DocsNav';
import PrevNext from '../components/developers/PrevNext';
import StartTopic from '../components/developers/StartTopic';
import ClientTopic from '../components/developers/ClientTopic';
import DesktopTopic from '../components/developers/DesktopTopic';
import ToolsTopic from '../components/developers/ToolsTopic';
import RulesTopic from '../components/developers/RulesTopic';
import HookTopic from '../components/developers/HookTopic';
import { clientBySlug } from '../components/developers/clients';
import { START, findTopic } from '../components/developers/topics';

// /developers — the integration docs as a two-column docs layout (spec:
// docs/superpowers/specs/2026-10-01-developers-docs-layout-design.md). One
// topic per page, each on its own path; switching topics is a regular Inertia
// visit, so back/forward, reload and sharing all work.
const Developers: React.FC<DevelopersPageProps> = (page) => {
  const current = page.topic ?? START;
  const client = clientBySlug(current);
  const toolCount = page.tool_groups.reduce((n, g) => n + g.tools.length, 0);

  let content: React.ReactNode;
  if (client?.kind === 'claude_desktop') content = <DesktopTopic client={client} />;
  else if (client) content = <ClientTopic client={client} page={page} />;
  else if (current === 'tools') content = <ToolsTopic groups={page.tool_groups} />;
  else if (current === 'rules') content = <RulesTopic sections={page.instructions} />;
  else if (current === 'worklog-hook') content = <HookTopic script={page.hook_script} prompt={page.hook_install_prompt} />;
  else content = <StartTopic groups={page.tool_groups} />;

  return (
    <>
      <Head title={`${findTopic(current).label} · 接入 asaptodo`} />
      <div className="mx-auto max-w-[1060px] md:flex md:gap-10 md:py-4">
        <DocsNav current={current} toolCount={toolCount} />
        <article className="min-w-0 max-w-[720px] flex-1">
          {content}
          <PrevNext current={current} />
        </article>
      </div>
    </>
  );
};

export default Developers;
